// © ООО «Эдиспа», 2022

import React from 'react';
import ReactPDF, { Text, View } from '@react-pdf/renderer';

import styles from 'components/pdf/table/styles';
import { Column } from 'components/pdf/table/types';

export interface HeaderProps {
  columns: Column[];
}

export default function Header(props: HeaderProps & ReactPDF.ViewProps) {
  const { columns, ...otherProps } = props;
  return (
    <View style={styles.header} {...otherProps}>
      {columns.map(column => (
        <View
          key={column.dataIndex}
          style={{
            width: column.width,
            flex: column.flex,
            textAlign: column.align || 'center'
          }}
        >
          <Text style={styles.cell}>{column.title}</Text>
        </View>
      ))}
    </View>
  );
}
